export default __webpack_public_path__ + "static/button-decoration-dont-dark-c812174a11b4fd1f3106ca0a8cd1242bccddf6c7d299c8b01db95a14fc417027.png";